// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Item_wrapper__1n2x6","icon":"Item_icon__XnOCq","title":"Item_title__1bWcm"};